import ScrollIcon from "components/svg-icons/scroll-icon";
import { MailOutlined } from "@ant-design/icons";
import moment from "moment";
import { getCurrentTimeZoneInfo } from "utils/dateutils";
import { useState } from "react";
import ErrorBoundary from "components/error-boundary";
import { useHistory, useParams } from "react-router-dom";
import ReportCardV2 from "../components/report-card-v2";
import { useUpcomingMilestones } from "./hooks/upcoming-milestones";
import ConfigureUpcomingMilestones from "./configure-upcoming-milestones";

function EmailAlertStatusComponent(props: any) {
  const { schedule, isDataLoaded } = props;

  if (!isDataLoaded)
    return (
      <div className="bg-ciq-neutral-50 text-center text-sm px-3 py-2">
        <div>&nbsp;</div>
      </div>
    );

  const enabled = schedule?.enabled;

  if (isDataLoaded && !enabled) {
    return (
      <div
        className="bg-ciq-neutral-50 text-center text-sm px-3 py-2"
        data-testid="email-alert-status-off"
      >
        <div className="text-black text-opacity-85">Email Alerts Off</div>
      </div>
    );
  }

  const timein12HourFormat = moment(schedule.schedule_input.hour, "HH").format(
    "hA"
  );

  const projectTimeZone = getCurrentTimeZoneInfo();

  return (
    <div
      className="bg-ciq-blue-100 text-center text-xs px-3 py-2 flex items-center"
      data-testid="email-alert-status-on"
    >
      <div className="flex items-center leading-none">
        <MailOutlined
          className="text-black text-opacity-45"
          style={{ fontSize: "14px" }}
        />{" "}
        <span className="text-ciq-gray-700 font-bold text-sm ml-1">Active</span>
      </div>
      <div className="grow text-right leading-none">
        Every {schedule.schedule_input.week_day} at {timein12HourFormat} (
        {projectTimeZone.code})
      </div>
    </div>
  );
}

function UpcomingMilestonesReportCardWrapper(props: any) {
  const { cardDetails } = props;
  const history = useHistory();
  const { projectId } = useParams<{ projectId: string }>();

  const [openConfigureUpcomingMilestones, setOpenConfigureUpcomingMilestones] =
    useState(false);

  const upcomingMilestonesHook = useUpcomingMilestones();

  const { firstNotificationSchedule, notificationSchedules } =
    upcomingMilestonesHook;

  return (
    <>
      <ReportCardV2
        title="Procurement Follow-Ups"
        icon={<ScrollIcon size={48} />}
        onViewClick={() => {
          history.push(`/project/${projectId}/reports/procurement-follow-ups`);
        }}
        onConfigureClick={() => {
          setOpenConfigureUpcomingMilestones(true);
        }}
        configureButtonProps={{
          disabled:
            notificationSchedules?.loading || notificationSchedules?.error
        }}
        detail={cardDetails.upcomingMilestones}
        status={
          <ErrorBoundary>
            <EmailAlertStatusComponent
              schedule={firstNotificationSchedule}
              isDataLoaded={
                !notificationSchedules?.loading && !notificationSchedules?.error
              }
              data-testid="upcoming-milestones-report-email-alert-status"
            />
          </ErrorBoundary>
        }
        data-testid="upcoming-milestones-report-card"
      />
      <ErrorBoundary>
        <ConfigureUpcomingMilestones
          open={openConfigureUpcomingMilestones}
          setOpen={setOpenConfigureUpcomingMilestones}
          upcomingMilestonesHook={upcomingMilestonesHook}
          data-testid="upcoming-milestones-report-configure-modal"
        />
      </ErrorBoundary>
    </>
  );
}

export default UpcomingMilestonesReportCardWrapper;
